<app-simple-modal-header [pageTitle]="pageTitle" (dismissed)="dismiss()">
	<form [formGroup]="filterForm" *ngIf="filterForm">
		<ion-list mode="md">
			<ion-item mode="md">
				<ion-label position="stacked" mode="md">Category</ion-label>
				<ion-select class="text-wrap"
							placeholder="Select"
							[interfaceOptions]="{ header: 'Category' }"
							(ionChange)="onChangeCategory($event.detail.value)"
							[formControl]="filterForm.controls.categoryId">
					<ion-select-option *ngFor="let category of categoryOptions"
									   [value]="category.id">
						{{ category.name }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ng-container *ngIf="foundEquipment; else empty">
				<ion-item mode="md">
					<ion-label position="stacked" mode="md">Equipment</ion-label>
					<ion-select class="text-wrap"
								placeholder="Select"
								[interfaceOptions]="{ header: 'Equipment' }"
								(ionChange)="onChangeEquipment($event.detail.value)"
								[formControl]="filterForm.controls.equipmentId">
						<ion-select-option *ngFor="let equipment of equipmentOptions"
										   [value]="equipment.id">
							{{ equipment.name }}
						</ion-select-option>
					</ion-select>
				</ion-item>
			</ng-container>
			<ng-container *ngIf="equipmentSelected">
				<ion-item mode="md">
					<ion-label position="stacked" mode="md">
						{{ primaryAttributeName }}
					</ion-label>
					<ion-input readonly="true"
							   placeholder="Select"
							   [formControl]="filterForm.controls.primaryAttribute"
							   (click)="onClickOpenSearchModal($event)">
					</ion-input>
				</ion-item>
			</ng-container>

		</ion-list>
	</form>

	<ion-buttons slot="end" *ngIf="canToggle">
		<ion-button (click)="toggleMode()">
			<ion-icon name="car-outline"></ion-icon>
		</ion-button>
	</ion-buttons>
</app-simple-modal-header>

<ion-content>
	<form [formGroup]="dynamicAttributesForm" *ngIf="dynamicAttributesForm">
		<ion-list lines="full" mode="md">

			<ion-item mode="md">
				<ion-label position="stacked" class="bold" mode="md">Customer Service</ion-label>
				<ion-select class="text-wrap"
							placeholder="Select"
							[interfaceOptions]="{ header: 'Customer Service' }"
							[formControl]="filterForm.controls.customerServiceId">
					<ion-select-option [value]="serviceOptionDefault.id">
						{{ serviceOptionDefault.desc }}
					</ion-select-option>
					<ion-select-option *ngFor="let service of appointment.services"
									   [value]="service.id">
						{{ service.desc }}
					</ion-select-option>
				</ion-select>
			</ion-item>

			<ion-item *ngFor="let attribute of dynamicAttributes; index as index"
					  mode="md">
				<ion-label position="stacked" class="bold" mode="md">
					{{ attribute.attribute }}
					<ion-text *ngIf="attribute.isRequired" color="danger">
						*
					</ion-text>
				</ion-label>
				<ion-input *ngIf="attribute.dataType == 'int'"
						   (keypress)="inventoryFormHelper.preventNonInteger($event)"
						   type="number"
						   [formControl]="dynamicAttributesForm.controls[index]"></ion-input>
				<ion-input *ngIf="attribute.dataType == 'char'"
						   (keypress)="
						inventoryFormHelper.preventNonAlphaCharacter($event)
					"
						   [formControl]="dynamicAttributesForm.controls[index]"></ion-input>
				<ion-input *ngIf="attribute.dataType == 'varchar'"
						   [formControl]="dynamicAttributesForm.controls[index]"></ion-input>
				<ion-input *ngIf="attribute.dataType == 'money'"
						   type="tel"
						   (keypress)="inventoryFormHelper.preventNonCurrency($event)"
						   (ionBlur)="inventoryFormHelper.formatMoneyInput($event)"
						   [formControl]="dynamicAttributesForm.controls[index]"></ion-input>
				<ion-input *ngIf="attribute.dataType == 'datetime'"
						   [formControl]="dynamicAttributesForm.controls[index]"
						   id="addTruckInventoryOpenCalendar{{index}}"
						   readonly="true"></ion-input>
				<ion-popover trigger="addTruckInventoryOpenCalendar{{index}}" show-backdrop="true">
					<ng-template>
						<ion-datetime [showDefaultButtons]="true"
									  [value]="inventoryFormHelper.toDateTimeString(dynamicAttributesForm.controls[index].value)"
									  (ionChange)="dynamicAttributesForm.controls[index].setValue(inventoryFormHelper.toInventoryDateString($event.target.value))"></ion-datetime>
					</ng-template>
				</ion-popover>
				<ion-select *ngIf="attribute.dataType == 'boolean'"
							[formControl]="dynamicAttributesForm.controls[index]">
					<ion-select-option [value]="''"></ion-select-option>
					<ion-select-option [value]="'No'">
						No
					</ion-select-option>
					<ion-select-option [value]="'Yes'">
						Yes
					</ion-select-option>
				</ion-select>
				<ion-select *ngIf="attribute.dataType == 'customerservice'"
							[compareWith]="inventoryFormHelper.serviceCompareWith"
							[formControl]="dynamicAttributesForm.controls[index]">
					<ion-select-option [value]="''"></ion-select-option>
					<ion-select-option *ngFor="let service of serviceOptions"
									   [value]="service.id">
						{{ service.desc }}
					</ion-select-option>
				</ion-select>
			</ion-item>
		</ion-list>
	</form>
</ion-content>

<ion-footer>
	<ion-button
		expand="full"
		class="modal__submit"
		(click)="onClickAddInventory()"
	>
		Add Inventory
	</ion-button>
</ion-footer>

<ng-template #empty>
	<ng-container *ngIf="categorySelected">
		<app-empty-list-item *ngIf="foundEquipment === false"
							 message="No equipment of this category is available on your truck.">
		</app-empty-list-item>
	</ng-container>
</ng-template>
